/* FORCIANO: keep the horizontal scroll position of the variant image tiles
   when a variant is selected (the picker is re-rendered by the theme and would jump back to the start). */
(function () {
  var SEL = '.swatches:has(.with-image)';
  var KEY = 'forciano-swatch-scroll';
  var pos = {};
  var tracked = [];
  var queued = false;

  function list() {
    try { return Array.prototype.slice.call(document.querySelectorAll(SEL)); } catch (e) { return []; }
  }

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ p: location.pathname, pos: pos })); } catch (e) {}
  }

  function record(el) {
    if (!el) return;
    var i = list().indexOf(el);
    if (i > -1) { pos[i] = el.scrollLeft; save(); }
  }

  function containerOf(t) {
    if (!t || !t.closest) return null;
    try { return t.closest(SEL); } catch (e) { return null; }
  }

  function restore() {
    queued = false;
    var els = list();
    els.forEach(function (el, i) {
      if (tracked[i] !== el) {
        tracked[i] = el;
        if (pos[i] > 0) el.scrollLeft = pos[i];
      }
    });
    tracked.length = els.length;
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(restore);
  }

  function init() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (s && s.p === location.pathname && s.pos) pos = s.pos;
    } catch (e) {}
    restore();
    new MutationObserver(function () {
      /* restore synchronously first so there is no visible jump, then once more after layout */
      restore();
      queue();
    }).observe(document.body, { childList: true, subtree: true });

    /* remember the position while scrolling ... */
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      var ok = false;
      try { ok = t.matches(SEL); } catch (err) {}
      if (ok) record(t);
    }, true);

    /* ... and right before a tile is chosen, so the position is never lost */
    ['pointerdown', 'click', 'change'].forEach(function (type) {
      document.addEventListener(type, function (e) { record(containerOf(e.target)); }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();